"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;
var _default = {
  "setOwner(address)": "Set `$1` as the new owner",
  "setOwner(bytes32,address)": "Set `$2` as the new owner of the `$1` node",
  "transfer(address,uint256)": "Transfer `@tokenAmount(self, $2)` to `$1`",
  "payday()": "Get owed Payroll allowance",
  "approveAndCall(address,uint256,bytes)": "Approve `$1` to spend `@tokenAmount(self, $2)` on your behalf and trigger a function in the contract at `$1`"
};
exports.default = _default;